import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import * as Helper from "../../utils/Helper";
import BaseComponent from "./BaseComponent";
// import CommonUpgradeModal from "../ui/CommonUpgradeModal";
import LoadScreenErrorHandler from "./LoadScreenErrorHandler";

class BaseScreen extends BaseComponent {
    get viewName() {
        return this.routeName;
    }

    get isLogoutScreen() {
        return false;
    }

    get routeName() {
        throw new Error("Not implemented.");
    }

    get callUpHandlers() {
        return {};
    }

    get loadScreenActionTypes() {
        return [`${this.routeName}.loadScreenViewAsync`];
    }

    refreshScreen() {
        if (this.props.loadScreenViewAsync) {
            this.props.loadScreenViewAsync();
        }else{
            throw new Error("Not implemented.");
        }
    }

    displayAsyncActionError(error, asyncActionErrorMsg) {
        let formattedError = {...error};
        formattedError.message = this.props.t(asyncActionErrorMsg, {reason: error.message, code: error.code});
        this.displayError(formattedError);
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);

        if (this.props) {
            //this.componentHandleCallUp(prevProps, this.props, false);
        }
    }

    /*componentHandleCallUp(nowProps, nextProps, forStarUp) {
        //we dont want to call multiple times
        let callUpParam = null;
        //for just navigation to page condition, we just see if we have navParams and it contains related data
        if (forStarUp) {
            const navParam = NavigationService.getNavParams(nextProps);
            if (navParam && navParam.callUpParam && navParam.callUpParam.fromCallUpApp && navParam.callUpParam.callUpType) {
                callUpParam = navParam.callUpParam;
            }
        } else {
            //for recieve props condition, we will have a refreshParams caused by navigation.refresh
            //so we compare if next props refreshParams is different

            //for refresh page case, we get refresh param first
            const nextRefreshParam = NavigationService.getRefreshParams(nextProps);
            const nowRefreshParam = NavigationService.getRefreshParams(nowProps);
            if (nextRefreshParam) {
                //if exist refresh param, we get the param for call up and compare if it is same as now
                //if same, we should not trigger since it may trigger more time
                const nextRefreshCallUpParam = nextRefreshParam.callUpParam;
                let nowRefreshCallUpParam = null;
                if (nowRefreshParam && nowRefreshParam.callUpParam) {
                    nowRefreshCallUpParam = nowRefreshParam.callUpParam;
                }
                if (nextRefreshCallUpParam && !_.isEqual(nextRefreshCallUpParam, nowRefreshCallUpParam)) {
                    if (nextRefreshCallUpParam.fromCallUpApp && nextRefreshCallUpParam.callUpType) {
                        callUpParam = nextRefreshCallUpParam;
                    }
                }
            }

            //there is a wired case that if your page is cached and we are go (back) to your page again
            //it will go to componentWillReceiveProps and has navParams as param
            //code below will handle this case
            const nextRefreshNavParam = NavigationService.getNavParams(nextProps);
            const nowRefreshNavParam = NavigationService.getNavParams(nowProps);
            if (nextRefreshNavParam) {
                //if exist refresh param, we get the param for call up and compare if it is same as now
                //if same, we should not trigger since it may trigger more time
                const nextRefreshCallUpNavParam = nextRefreshNavParam.callUpParam;
                let nowRefreshCallUpNavParam = null;
                if (nowRefreshNavParam && nowRefreshNavParam.callUpParam) {
                    nowRefreshCallUpNavParam = nowRefreshNavParam.callUpParam;
                }
                if (nextRefreshCallUpNavParam && !_.isEqual(nextRefreshCallUpNavParam, nowRefreshCallUpNavParam)) {
                    if (nextRefreshCallUpNavParam.fromCallUpApp && nextRefreshCallUpNavParam.callUpType) {
                        callUpParam = nextRefreshCallUpNavParam;
                    }
                }
            }
        }

        if (callUpParam) {
            //call type should be a number
            if (_.isNumber(callUpParam.callUpType)) {
                if (this.callUpHandlers[callUpParam.callUpType]) {
                    if (_.isFunction(this.callUpHandlers[callUpParam.callUpType])) {
                        this.callUpHandlers[callUpParam.callUpType](callUpParam);
                    }
                }
            }
        }
    }*/

    componentHandleActionDone(action, nextProps) {
        if (!_.isEmpty(action.type)) {
            //if current login user is deactivate account then we need to pop up an alert to logout user.
            // if (action.isDone && action.data && action.data.latestApps) {
            //     setTimeout(() => {
            //         var appLatest = Platform.OS === "ios" ? action.data.latestApps.iosApp : action.data.latestApps.androidApp;
            //         if (appLatest) CommonUpgradeModal.checkIfNeedUpgrade(appLatest.latestVersion, appLatest.downloadLink);
            //     }, 200);
            // }

            super.componentHandleActionDone(action, nextProps);
        }
    }

    isGuest = Helper.isGuest;

    isLoggedIn = Helper.isLoggedIn;

    renderScreen() {
        throw new Error("Not implemented.");
    }

    render() {
        const curAction = this.props.localState.action;
        if (curAction && this.loadScreenActionTypes.includes(curAction.type) && curAction.error) {
            return <LoadScreenErrorHandler screenID={this.routeName} error={curAction.error}
                onReload={() => this.refreshScreen()} />;
        } else {
            return this.renderScreen();
        }
    }
}

BaseScreen.propTypes = {
    userId: PropTypes.string,
};

BaseScreen.isGuest = Helper.isGuest;
BaseScreen.isLoggedIn = Helper.isLoggedIn;

export default BaseScreen;
